import script from "./UsersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersModal.vue?vue&type=script&setup=true&lang=js"

import "./UsersModal.vue?vue&type=style&index=0&id=aa7e3d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa7e3d34"]])

export default __exports__